import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography
} from '@mui/material';

import { get } from 'src/services/httpClient.service';
import { authenticationService } from 'src/services';


const SubscriberRegistrationStats = () => {
  const API_URL = process.env.REACT_APP_BASE_API_URL;

  const { status } = useParams<{ status: string }>();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

    const { vendorId, franchiseId} = authenticationService.getVendorFranchiseIds();

  
  const [filterDate, setFilterDate] = useState(
  new Date().toISOString().split('T')[0]
);

  useEffect(() => {
    fetchSubscribers();
  }, [status,filterDate]);

  const fetchSubscribers = async () => {
    try {
      setLoading(true);

      const response = await get(
        `${API_URL}/api/subscriber/vendor/${vendorId}/franchise/${franchiseId}/getSubscribersByDateActions?reportType=${status}&filterDate=${filterDate}`
      );

      setRows(response?.userList || response || []);
      console.log('response',response?.userList)
    } catch (error) {
      console.error('Error fetching subscribers:', error);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  const getPageTitle = () => {
    switch (status) {
      case 'ATCIVATED':
        return 'Activated Subscribers';

      case 'DE_ATCIVATED':
        return 'Deactivated Subscribers';

      case 'RE_ATCIVATED':
        return 'Reactivated Subscribers';

      default:
        return 'Subscriber Registration Stats';
    }
  };

  const handleChangePage = (
    event: unknown,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>
        {getPageTitle()}
      </Typography>

      <Grid container spacing={2} sx={{ mb: 2 }}>
  <Grid item xs={12} sm={4} md={3}>
    <TextField
      fullWidth
      size="small"
      type="date"
      label="Filter Date"
      value={filterDate}
      onChange={(e) => setFilterDate(e.target.value)}
      InputLabelProps={{
        shrink: true
      }}
    />
  </Grid>
</Grid>

      <Paper
        sx={{
          minHeight: 'calc(100vh - 220px)',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <TableContainer sx={{ flex: 1 }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                
                <TableCell>
                  <b>Customer ID</b>
                </TableCell>
                <TableCell>
                  <b>Name</b>
                </TableCell>
                <TableCell>
                  <b>Email</b>
                </TableCell>
                <TableCell>
                  <b>Phone</b>
                </TableCell>
                <TableCell>
                  <b>Status</b>
                </TableCell>
               
                 

                
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    <Box
                      display="flex"
                      justifyContent="center"
                      py={3}
                    >
                      <CircularProgress />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : rows.length > 0 ? (
                rows
                  .slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                  .map((row: any, index: number) => (
                    <TableRow key={index} hover>

                      <TableCell>
                        {row.customerId}
                      </TableCell>


                      <TableCell>
                        {row.userName}
                      </TableCell>

                       <TableCell>
                        {row.email}
                      </TableCell>

                      <TableCell>
                        {row.phone || row.mobile}
                      </TableCell>

                      <TableCell>
                        {row.userStatus}
                      </TableCell>
                    
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    No Records Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={rows.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[10, 25, 50, 100]}
        />
      </Paper>
    </Box>
  );
};

export default SubscriberRegistrationStats;

